import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Card, Column, Divider, Row, Typography, useOverlayContext } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import { PlusCircle } from 'seagull/icons';
import { combinedRate, formatPercent } from '~/features/salesTax/rates';
import { useLocaleKeys } from '~/i18n';
import { CreateEditPresetModal } from '../CreateEditPresetModal/CreateEditPresetModal';
import { PresetRowActions } from '../PresetRowActions/PresetRowActions';
import { PresetMappingStatus } from './PresetMappingStatus/PresetMappingStatus';
export const TaxRatesSection = (param)=>{
    let { presets, isNameDuplicate, onSavePreset, onMapToQbo } = param;
    const { t } = useLocaleKeys('pages.salesTaxSettings.ratesSection');
    const { showModal } = useOverlayContext();
    const openPresetModal = (preset)=>{
        void showModal({
            biName: 'sales_tax_preset_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(CreateEditPresetModal, {
                    mode: preset == null ? 'create' : 'edit',
                    initial: preset,
                    isNameDuplicate: (name)=>{
                        var _ref;
                        return isNameDuplicate(name, (_ref = preset === null || preset === void 0 ? void 0 : preset.id) !== null && _ref !== void 0 ? _ref : null);
                    },
                    onSave: onSavePreset,
                    dismissModal: dismissModal
                });
            }
        });
    };
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'sales_tax_rates_card'
        },
        autoHeight: true,
        borderRadius: "m",
        children: /*#__PURE__*/ _jsxs(Column, {
            padding: 24,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 24,
                    children: [
                        /*#__PURE__*/ _jsxs(Column, {
                            gap: 4,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    weight: "normal",
                                    children: t.title()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    skin: "secondary",
                                    children: t.description()
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: 'sales_tax_create_preset'
                            },
                            onClick: ()=>openPresetModal(null),
                            children: /*#__PURE__*/ _jsxs(Row, {
                                gap: 6,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(PlusCircle, {
                                        size: 18
                                    }),
                                    t.createNew()
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                presets.length === 0 ? /*#__PURE__*/ _jsx(Box, {
                    padding: 32,
                    style: {
                        border: "1px solid ".concat(colors.dark200),
                        borderRadius: 8
                    },
                    children: /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        align: "center",
                        children: t.empty()
                    })
                }) : /*#__PURE__*/ _jsxs(Column, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            alignItems: "center",
                            style: {
                                backgroundColor: colors.dark100,
                                padding: '6px 16px'
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    style: {
                                        flex: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph3",
                                        skin: "secondary",
                                        children: t.columns.name()
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    width: 40
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    width: 100,
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph3",
                                        skin: "secondary",
                                        align: "right",
                                        children: t.columns.rate()
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    width: 40,
                                    style: {
                                        marginLeft: 8
                                    }
                                })
                            ]
                        }),
                        presets.map((preset)=>/*#__PURE__*/ _jsxs(Row, {
                                alignItems: "center",
                                style: {
                                    padding: '12px 16px',
                                    borderBottom: "1px solid ".concat(colors.dark100)
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Box, {
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            children: preset.name
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Row, {
                                        width: 40,
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ _jsx(PresetMappingStatus, {
                                            preset: preset
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Box, {
                                        width: 100,
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            align: "right",
                                            children: formatPercent(combinedRate(preset))
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Row, {
                                        width: 40,
                                        justifyContent: "end",
                                        style: {
                                            marginLeft: 8
                                        },
                                        children: /*#__PURE__*/ _jsx(PresetRowActions, {
                                            preset: preset,
                                            onEdit: openPresetModal,
                                            onMapToQbo: onMapToQbo
                                        })
                                    })
                                ]
                            }, preset.id))
                    ]
                })
            ]
        })
    });
};
